import { render } from "./acces_situation.vue?vue&type=template&id=34544e9e"
import script from "./acces_situation.vue?vue&type=script&lang=js"
export * from "./acces_situation.vue?vue&type=script&lang=js"

import exportComponent from "/build/9647e414-6daa-46b0-8fd7-b2edfb8f7f7d/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__